import { useQuery } from "@tanstack/react-query";
import { requestSessionByPasswordLogin } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
/**
 * Query a session via email and password login request.
 */ function useSessionByPasswordLoginRequest(email, password) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.createSessionByPasswordLogin(email), async ({ signal })=>{
        await rcbAuthenticationStore.sessionLogout(); // invalidate old session - if possible
        return requestSessionByPasswordLogin(email, password, {
            signal,
            language: "en"
        });
    }, {
        staleTime: Infinity,
        retry: false,
        enabled: !!email && !!password,
        onSuccess: (sessionResponse)=>{
            rcbAuthenticationStore.writeSessionToLocalStorage(sessionResponse);
        }
    });
}
export { useSessionByPasswordLoginRequest };
